<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { get_gen_2_component_channel_structure, real_id } from 'src/helpers/interface_helpers';
		import { format } from 'src/services/i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { Button, Select, toast } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);
	const component = get_gen_2_component_channel_structure(device);

	const SPEED_OPTIONS = [
		{ value: 0, i18nKey: 'raex_motor_speed_slow', fallback: 'Slow' },
		{ value: 1, i18nKey: 'raex_motor_speed_medium', fallback: 'Medium' },
		{ value: 2, i18nKey: 'raex_motor_speed_fast', fallback: 'Fast' },
	];

	let settings = $settingsStore;
	let currentValue = settings?.[component]?.motor?.speed ?? 1;
	let selected = currentValue;
	let cache = currentValue;
	let loading = false;

	const options = SPEED_OPTIONS.map((opt) => ({
		value: opt.value,
		title:
			$format(opt.i18nKey, {
				default: opt.fallback,
			}) || opt.fallback,
	}));

	const handleChange = (value: number) => {
		selected = Number(value);
	};

	const save = async () => {
		if (selected === cache) return;

		loading = true;

		const params = {
			id: device.channel ?? 0,
			config: {
				motor: {
					speed: selected,
				},
			},
		};

		const res: SettingRequest = await gen2Request(device, 'Cover.SetConfig', params);

		if (res.isok) {
			if (!settings[component].motor) {
				settings[component].motor = {};
			}
			settings[component].motor.speed = selected;
			devices_settings.update_devices_settings(id, settings);
			cache = selected;
			toast.open({
				type: 'success',
				title: $format('setting_scc_saved_toast', { default: 'Settings saved' }),
			});
		} else {
			selected = cache;
			toast.open({ type: 'danger', title: $format('error_global') });
		}

		loading = false;
	};
</script>

<Select
	size="m"
	width="full"
	{options}
	value={options.find((opt) => opt.value === selected) || options[1]}
	on:change={(e) => handleChange(e.detail['value'])}
	icon="fas fa-chevron-down"
	id="select-raex-motor-speed"
	aria-label={$format('raex_motor_speed_title', { default: 'Motor speed' })}
/>

<Button class="mt-s" {loading} size="m" width="full" on:click={save}>
	{$format('button_save')}
</Button>
